import { Environments } from 'src/constants/Environment';
import { envENVIRONMENT } from 'src/env/envENVIRONMENT';

export function envSTRIPE_PUBLIC_KEY(): string {
    return envENVIRONMENT() === Environments.PROD ? 'pk_live_uXyzUPnpEFqm2gOBsDuISVwM' : 'pk_test_BdMBnZlS8HZsMbDwi0DI6tLU';
}
